import createComponent from 'styles/fela/createComponent';
import { Text } from 'components';

export const CollectionText = createComponent(({ theme }) => ({
  fontWeight: '600',
  fontSize: theme.fontSize.medium,
  color: theme.color.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  flex: 1,
  minWidth: 0,
  lineHeight: 1.4,

  extend: [
    {
      condition: theme.collectionTitle?.style,
      style: {
        fontStyle: theme.collectionTitle?.style,
      },
    },
    {
      condition: theme.collectionTitle?.weight,
      style: {
        fontWeight: theme.collectionTitle?.weight,
      },
    },
  ],
}), Text);
